import { useNavigate } from 'react-router-dom'
import { SiteHeader } from '../components/SiteHeader'
import { TeamPanel } from '../components/team/TeamPanel'

/**
 * /account/team — desktop.
 *
 * ── THE PATH IS NOT A PREFERENCE ──────────────────────────────────────────
 * `functions/src/billing/index.ts` hardcodes
 * `RETURN_BASE = 'https://www.thediaex.com/account/team'` and returns buyers
 * from Stripe to `?seats=purchased|cancelled`. If this route did not exist,
 * `path="*"` would redirect a customer who has just been CHARGED to the home
 * page with no confirmation — a dead end on the money path.
 *
 * `Header` is always mounted, so Browse and the account menu are one click
 * away from every state the panel can render.
 */
export function AccountTeam() {
  const navigate = useNavigate()
  return (
    <>
      <SiteHeader />
      <main className="min-h-[60vh] pb-16">
        <TeamPanel onBack={() => navigate('/search')} />
      </main>
    </>
  )
}
